"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Upload = void 0;
const globalErrorCode_1 = require("../global/model/error/globalErrorCode");
const globalErrorMessages_1 = require("../global/model/error/globalErrorMessages");
const uploadError_1 = require("./model/error/uploadError");
class Upload {
    constructor(instance) {
        this.instance = instance;
    }
    uploadImage(token, image, onUploadProgress) {
        return new Promise((resolve, reject) => {
            const URL = '/uploads';
            if (!token) {
                reject(new uploadError_1.UploadError(globalErrorCode_1.GlobalErrorCode.INVALID_TOKEN, globalErrorMessages_1.GLOBAL_ERROR_MESSAGES[globalErrorCode_1.GlobalErrorCode.INVALID_TOKEN]));
                return;
            }
            const data = new FormData();
            data.set('file', image);
            const authStr = 'Bearer '.concat(token);
            const config = {
                headers: {
                    Authorization: authStr,
                },
            };
            if (onUploadProgress) {
                config.onUploadProgress = onUploadProgress;
            }
            this.instance.post(URL, data, config)
                .then((res) => {
                const image = res.data;
                resolve(image);
            })
                .catch((err) => {
                reject(new uploadError_1.UploadError(globalErrorCode_1.GlobalErrorCode.UNDEFINED_CODE, err.response.data.error));
            });
        });
    }
    getImages(token) {
        return new Promise((resolve, reject) => {
            const URL = '/uploads';
            if (!token) {
                reject(new uploadError_1.UploadError(globalErrorCode_1.GlobalErrorCode.INVALID_TOKEN, globalErrorMessages_1.GLOBAL_ERROR_MESSAGES[globalErrorCode_1.GlobalErrorCode.INVALID_TOKEN]));
                return;
            }
            const authStr = 'Bearer '.concat(token);
            const config = { headers: { Authorization: authStr } };
            this.instance.get(URL, config)
                .then((res) => {
                const images = res.data;
                resolve(images);
            })
                .catch((err) => {
                reject(new uploadError_1.UploadError(globalErrorCode_1.GlobalErrorCode.UNDEFINED_CODE, err.response.data.error));
            });
        });
    }
    deleteImageByID(token, id) {
        return new Promise((resolve, reject) => {
            const URL = `/uploads/${id}`;
            if (!token) {
                reject(new uploadError_1.UploadError(globalErrorCode_1.GlobalErrorCode.INVALID_TOKEN, globalErrorMessages_1.GLOBAL_ERROR_MESSAGES[globalErrorCode_1.GlobalErrorCode.INVALID_TOKEN]));
                return;
            }
            const authStr = 'Bearer '.concat(token);
            const config = { headers: { Authorization: authStr } };
            this.instance.delete(URL, config)
                .then((res) => {
                resolve(res.data.message === 'Successfully deleted');
            })
                .catch((err) => {
                reject(new uploadError_1.UploadError(globalErrorCode_1.GlobalErrorCode.UNDEFINED_CODE, err.response.data.error));
            });
        });
    }
}
exports.Upload = Upload;
//# sourceMappingURL=upload.js.map